import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import { DatePicker } from '@material-ui/pickers';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import {
  Box,
  Grid,
  FormControl,
  Input,
  InputLabel,
  Select,
  MenuItem,
  Divider,
} from '@material-ui/core';
import CircularProgress from 'components/shared/CircularProgress';
import ReceiptInformation, { Summary, types_translations } from './receipt-information';

const orders = [{
  value: 'id DESC',
  label: 'Created descending',
}, {
  value: 'id ASC',
  label: 'Created ascending',
}, {
  value: 'amount DESC',
  label: 'Amount descending',
}, {
  value: 'amount ASC',
  label: 'Amount ascending',
}];
const types = ['payin', 'payout', 'payment', 'refund', 'fee'];

const OrdersList = ({
  isLoading,
  list,
  changeFilter,
  changePicker,
  filters,
  hasMore,
}) => {
  return (
    <Box p={2}>
      <Box py={2}>
        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item xs={6} md={3}>
            <DatePicker
              name="paid_at_from"
              label={<FormattedMessage id="datefrom" defaultMessage="Date from" />}
              leftArrowIcon={<ArrowBack />}
              rightArrowIcon={<ArrowForward />}
              fullWidth
              value={filters.paid_at_from}
              cancelLabel={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
              clearLabel={<FormattedMessage id="Clear" defaultMessage="Clear" />}
              onChange={changePicker('paid_at_from')}
              clearable
              format="YYYY-MM-DD"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <DatePicker
              name="paid_at_to"
              label={<FormattedMessage id="dateto" defaultMessage="Date to" />}
              leftArrowIcon={<ArrowBack />}
              rightArrowIcon={<ArrowForward />}
              fullWidth
              value={filters.paid_at_to}
              cancelLabel={<FormattedMessage id="Cancel" defaultMessage="Cancel" />}
              clearLabel={<FormattedMessage id="Clear" defaultMessage="Clear" />}
              onChange={changePicker('paid_at_to')}
              clearable
              format="YYYY-MM-DD"
            />
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControl fullWidth>
              <InputLabel htmlFor="order-by">
                <FormattedMessage
                  id="orderby"
                  defaultMessage="Order by"
                />
              </InputLabel>
              <Select
                name="order"
                value={filters.order}
                input={<Input id="orderby-by" />}
                onChange={changeFilter('order')}
              >
                {orders.map((order) => (
                  <MenuItem
                    key={order.label}
                    value={order.value}
                  >
                    <FormattedMessage id={`orders.sort.${order.label}`} defaultMessage={order.label} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <FormControl fullWidth>
              <InputLabel htmlFor="filter-by">
                <FormattedMessage
                  id="Filter by"
                  defaultMessage="Filter by"
                />
              </InputLabel>
              <Select
                value={filters.type || ''}
                input={<Input id="filter-by" />}
                onChange={changeFilter('type')}
              >
                <MenuItem value="__none__">
                  <FormattedMessage id="all" defaultMessage="All" />
                </MenuItem>
                {types.map((name) => (
                  <MenuItem
                    key={name}
                    value={name}
                  >
                    {types_translations[name.toUpperCase()]}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
        </Grid>
      </Box>
      {
        (!isLoading && list.length === 0) && (
          <Alert severity="info" elevation={3}>
            <FormattedMessage
              id="payment.noReceipts"
              defaultMessage="No receipts were found"
            />
          </Alert>
        )
      }
      {list.map((order, i) => (
        <Box
          key={i}
          my={1}
          boxShadow={3}
        >
          <ReceiptInformation order={order} />
        </Box>
      ))}
      {isLoading && <CircularProgress />}
      {
        !isLoading && !hasMore && !!list.length && (
          <Summary orders={list} />
        )
      }
    </Box>
  );
};

OrdersList.propTypes = {
  isLoading: PropTypes.bool,
  list: PropTypes.arrayOf(PropTypes.shape({

  })).isRequired,
  changeFilter: PropTypes.func.isRequired,
  changePicker: PropTypes.func.isRequired,
  filters: PropTypes.shape({
    paid_at_from: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    paid_at_to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    order: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  hasMore: PropTypes.bool.isRequired,
};

export default OrdersList;
